// extracted by mini-css-extract-plugin
export var button = "user-details-section-module--button--6841e";
export var buttonWrapper = "user-details-section-module--buttonWrapper--d9277";
export var emailField = "user-details-section-module--emailField--5695d";
export var item = "user-details-section-module--item--84e5d";
export var label = "user-details-section-module--label--3c307";
export var section = "user-details-section-module--section--db598";